var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RichTextInput"},[(_vm.tinyConfig)?_c('Editor',{attrs:{"api-key":"no-api-key","init":_vm.tinyConfig},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }